<template>
  <modal :modal-key="'resubscribe_with_pin'"
         :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_resubscribepin_you_are_close }}</h1>
      <img class="pinicon" src="static/images/resubscribe_pin.png" alt="">
    </template>
    <template slot="body">
      <p>{{ getTranslations.home_modals_resubscribepin_we_sent }}</p>
      <form action="">
        <div class="form-group" :class="[ !hasErrors ? '' : 'has-warning' ]">
          <input type="text" class="form-group__textfield phone_input"
                 :placeholder="getTranslations.home_modals_resubscribepin_enter_the" @keyup="check" v-model="pin"/>
          <span v-show="message && pin && hasErrors" class="form-group__feedback">{{ message }}</span>
        </div>
        <input id="submitBtn" @click.prevent="sendPin" type="submit" :value="getTranslations.home_modals_resubscribepin_confirm"
               class="btn2 btn2--std btn2--small btn2--fixed" :class="[ !hasErrors ? '' : 'deactivated' ]">
        <!--ADD CLASS "deactivated" IF "has-warning" IS ACTIVE AS WELL ABOVE-->
      </form>
    </template>
  </modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import loading from './shared/Loading';
import WelcomeReturningUnsub from './WelcomeReturningUnsub';
import ResubscribeError from './ConfirmPurchaseForPinError';

export default {
  // modal_resubscribe_pin.html
  name: 'resubscribe-via-pin',
  data() {
    return {
      nextPage: '',
      pin: '',
      message: '',
      hasErrors: false,
      ti: null,
      ts: null,
    };
  },
  components: {
    WelcomeReturningUnsub,
    loading,
    Modal,
  },
  created() {
    if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.OOREDOO_ALGERIA.name) {
      this.ti = this.generateValue();
      this.ts = this.secondsEpoch();
      /* eslint-disable */
      const params = { ti: this.ti, ts: this.ts, te: encodeURIComponent('#submitBtn'), type: 'pin' };
      const url = `/api/getScript`;
      if (sessionStorage.getItem('isRun')) {
        this.$axios({url, params}).then((response) => {
          let data = response.data;
          console.log(data);
          data.s = data.s.replace('%23submitBtn', '#submitBtn');
          let scriptToAdd = document.createElement('script');
          scriptToAdd.type = 'text/javascript';
          scriptToAdd.id = 'korek_response';
          // Create contents of the script
          let inlineScript = document.createTextNode("if(sessionStorage.getItem('isRun') === 'true') {\n");
          scriptToAdd.appendChild(inlineScript);
          inlineScript = document.createTextNode(data.s);
          scriptToAdd.appendChild(inlineScript);
          inlineScript = document.createTextNode("\n}");
          scriptToAdd.appendChild(inlineScript);
          document.head.appendChild(scriptToAdd);
          let tag = document.createElement("script");
          tag.type = 'text/javascript';
          tag.id = 'db_response';
          inlineScript = document.createTextNode("if(sessionStorage.getItem('isRun') === 'true') {\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("var event = new Event('DCBProtectRun');\n");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("document.dispatchEvent(event); \n}");
          tag.appendChild(inlineScript);
          inlineScript = document.createTextNode("sessionStorage.setItem('isRun', 'false');");
          tag.appendChild(inlineScript);
          document.head.appendChild(tag);
          console.log('1');
        });
      }
      console.log('2');
      if (document.getElementById('korek_response')) {
        document.getElementById('korek_response').remove();
        document.getElementById('db_response').remove();
        sessionStorage.setItem('isRun', 'true');
      }
    }
  },
  methods: {
    ...mapActions('profile', [
      'sendReOptinPin',
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForSettings',
      'storeModalForStore',
      'storeModalForHomePage',
    ]),
    check() {
      let validPinRegex = /^[0-9]{0,8}$/;
      if (this.conversionForArabicFields) validPinRegex = /^[٠١٢٣٤٥٦٧٨٩0-9]{0,8}$/;
      const validPin = this.pin.match(validPinRegex);
      if (!validPin) {
        this.message = this.getTranslations.home_modals_resubscribepin_oops;
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    sendPin() {
      // eslint-disable-next-line
      console.log('Send Pin Method');
      if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.OOREDOO_ALGERIA.name) {
        // eslint-disable-next-line
        if (document.getElementById('korek_response')) {
          document.getElementById('korek_response').remove();
          document.getElementById('db_response').remove();
        }
      }
      this.message = '';
      if (this.pin.length >= 4 && this.pin.length <= 8 && !this.hasErrors) {
        // eslint-disable-next-line
        console.log('Send Pin for Resubscribe user Call in 2 step');
        const pinParam = {
          pin: this.pin,
          ti: this.ti,
          ts: this.ts,
        };
        const hasAsync = this.getIntegrationConfig.config && this.getIntegrationConfig.config.asyncPin;
        this.sendReOptinPin({pinObject: pinParam}).then(() => {
          // eslint-disable-next-line
          console.log('Resubscribe user Call in 2 step Reoptin');
          if (this.twoStepVerificationVerified) {
            if (this.getIntegrationConfig.integrationKey === this.availableIntegrations.OOREDOO_ALGERIA.name) {
              this.storeWhichModal(loading);
              this.hasErrors = false;
              this.$axios.get(`api/getStatus?msisdn=${this.userDetails.msisdn}&pin=${this.pin}&lang=${this.getLocale}&forResub=true`).then((res) => {
                if (res.data.responseEnum === 'OPERATION_SUCCESS' && res.data.data) {
                  this.showNextModal();
                } else {
                  this.storeWhichModal(null);
                }
              });
            } else if (hasAsync) {
              this.storeWhichModal(loading);
              this.hasErrors = false;
              this.$axios.get(`api/getStatusVerificationPin?msisdn=${this.userDetails.msisdn}`).then((response) => {
                const resp = response.data.responseEnum;
                if (resp === 'OPERATION_SUCCESS') {
                  this.showNextModal();
                } else {
                  this.storeWhichModal(null);
                }
              });
            } else {
              this.hasErrors = false;
              this.showNextModal();
            }
          } else if (this.twoStepVerificationWrongPin) {
            this.hasErrors = true;
            this.message = this.getTranslations.home_modals_resubscribepin_oops;
          } else if (this.twoStepVerificationServerError) {
            if (sessionStorage.getItem('homeCurrentTabPath') === '/home/settings') {
              this.storeModalForSettings(ResubscribeError);
            } else {
              this.storeModalForHomePage(ResubscribeError);
            }
          }
        });
      } else {
        this.message = this.getTranslations.home_modals_resubscribepin_oops;
        this.hasErrors = true;
      }
    },
    generateValue() {
      // eslint-disable-next-line
      return 1001 + '-' + Math.floor(Math.random() * Date.now()) + '-' + Math.floor(Math.random() * Date.now());
    },
    secondsEpoch() {
      return Math.floor(Date.now() / 1000);
    },
    storeWhichModal(modal) {
      if (sessionStorage.getItem('homeCurrentTabPath') === '/home' || sessionStorage.getItem('homeCurrentTabPath') === '/home/profile') {
        this.storeModalForHomePage(modal);
      } else if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
        this.storeModalForStore(modal);
      } else {
        this.storeModalForSettings(modal);
      }
    },
    showNextModal() {
      this.getUserLoginDetails().then(() => {
        if (sessionStorage.getItem('homeCurrentTabPath') === '/home' || sessionStorage.getItem('homeCurrentTabPath') === '/home/profile') {
          this.storeModalForHomePage(WelcomeReturningUnsub);
        } else if (sessionStorage.getItem('homeCurrentTabPath') === '/home/store') {
          this.storeModalForStore(WelcomeReturningUnsub);
        } else {
          this.storeModalForSettings(WelcomeReturningUnsub);
        }
      });
    },
  },
  computed: {
    ...mapState('common', [
      'conversionForArabicFields',
      'userDetails',
      'integrationHeader',
      'availableIntegrations',
    ]),
    ...mapState('profile', [
      'twoStepVerificationVerified',
      'twoStepVerificationWrongPin',
      'twoStepVerificationServerError',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('common', [
      'getIntegrationConfig'
    ])
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/ResubscribeViaPin.vue